
export interface InterfaceRouteDefinition {
  path: string
}

interface InterfaceRoutes {
  [name: string]: InterfaceRouteDefinition
}

const routingConfig: InterfaceRoutes = {
    landingPage: {
        path: "/transportorders",
    },
    transportOrderOverview: {
        path: "/transportorders",
    },
    inboundTransportOrderOverview: {
        path: "/inbound-transportorders",
    },
    transportOrderPresenter: {
        path: "/transportorder/:id",
    },
    closingDays: {
        path: "/closing-days"
    },
    notificationSettings: {
        path: "/notifications",
    },
    transportExecution: {
        path: "/shipments",
    },
    rioAdminTransportOrders: {
        path: "/rio-admin/transport-orders",
    },
}

export { routingConfig }